import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { EMPTY, Observable, of, Subscription } from "rxjs";
import { switchMap } from "rxjs/operators";
import { ErrorDialogComponent } from "../error-dialog/error-dialog.component";
import { ApiService } from "../services/api.service";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";
import { MatTableListComponent } from "../mat-table-list/mat-table-list.component";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatDivider } from "@angular/material/divider";


@Component({
    selector: "app-dialog",
    templateUrl: "./dialog.component.html",
    styleUrls: ["./dialog.component.css"],
    standalone: true,
    imports: [
    MatDialogTitle,
    MatDivider,
    CdkScrollable,
    MatDialogContent,
    MatTableListComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatIcon
],
})
export class DialogComponent implements OnInit, OnDestroy {
  modelName: string;
  modelDefinition: any;
  selectedLines: any;
  modelDefinition$: Observable<any>;
  modelDefinitionSubscription: Subscription;
  images$: Observable<any>;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    public dialogBox: MatDialog
  ) {}
  ngOnDestroy(): void {
    this.modelDefinitionSubscription?.unsubscribe();
  }
  ngOnInit(): void {
    if (this.data.modelName) {
      this.modelName = this.data.modelName;
      this.modelDefinition$ = this.apiService.getModel(this.modelName).pipe(
        switchMap((res) => {
          if (res) {
            // this.apiService.InsertModel(res);
            return of(res);
          } else {
            // not found
            const message = `Impossible de trouver le modèle ${this.modelName}`;
            this.openErrorDialog("MODEL_NOT_FOUND", message);
            this.dialogRef.close();
            return EMPTY;
          }
        })
      );
      this.modelDefinitionSubscription = this.modelDefinition$.subscribe(
        (res) => {
          this.modelDefinition = res;
          this.modelDefinition.hideInputSearch = this.data.hideInputSearch;
        }
      );
    }
  }
  onOkClick(): void {
    this.dialogRef.close();
  }
  openErrorDialog(title: string, message: string): void {
    const data = { title: title, error: message };
    this.dialogBox.open(ErrorDialogComponent, {
      width: "400px",
      data,
    });
  }
}
